import { FeatureFlag } from '../FeatureFlag';

export const enableTradingOrderManagementFiltering = new FeatureFlag({
    key: 'enable-trading-order-management-filtering',
    defaultValue: false,
});
